import gql from 'graphql-tag';

export const FIND_OR_CREATE_WALLET_PAYMENT = gql`
    mutation {
        findOrCreateWalletPaymentType {
            id
        }
    }
`;